/* src/contexts/profile/profileCloudFunctions.js */
import { getFunctions, httpsCallable } from 'firebase/functions';
import { functions as functionsInstance } from '../../firebaseConfig'; // Assuming functions instance is exported from firebaseConfig

// Initialize variables to hold the function references (default to null)
let deleteProfileAndCleanupFn = null;
let sendFriendRequestFn = null;
let acceptFriendRequestFn = null;
let handleFriendRequestFn = null; // Function for reject/cancel
let removeFriendFn = null;
let searchUsersFn = null;
let setProfileUsernameFn = null;
let checkSubscriptionStatusFn = null;
let fetchUserSessionsFn = null;
let exportUserSessionsFn = null;
let getUserDataOnLoginFn = null; // <<< ADDED variable for the new function

// Define the names of your Cloud Functions as deployed
const functionNames = {
  getUserDataOnLogin: 'getUserDataOnLogin', // <<< ADDED function name mapping
  deleteProfile: 'deleteProfileAndCleanup',
  sendRequest: 'sendFriendRequest',
  acceptRequest: 'acceptFriendRequest',
  handleRequest: 'handleFriendRequest', // Combined reject/cancel function name
  removeFriend: 'removeFriend',
  searchUsers: 'searchUsers',
  setProfileUsername: 'setProfileUsername',
  checkSubscription: 'checkSubscriptionStatus',
  fetchUserSessions: 'fetchUserSessions',
  exportUserSessions: 'exportUserSessions'
};

try {
  // Ensure the functions instance from firebaseConfig is valid
  if (functionsInstance) {
    // Get callable references for each function
    getUserDataOnLoginFn = httpsCallable(functionsInstance, functionNames.getUserDataOnLogin); // <<< GET callable reference
    deleteProfileAndCleanupFn = httpsCallable(functionsInstance, functionNames.deleteProfile);
    sendFriendRequestFn = httpsCallable(functionsInstance, functionNames.sendRequest);
    acceptFriendRequestFn = httpsCallable(functionsInstance, functionNames.acceptRequest);
    handleFriendRequestFn = httpsCallable(functionsInstance, functionNames.handleRequest);
    removeFriendFn = httpsCallable(functionsInstance, functionNames.removeFriend);
    searchUsersFn = httpsCallable(functionsInstance, functionNames.searchUsers);
    setProfileUsernameFn = httpsCallable(functionsInstance, functionNames.setProfileUsername);
    checkSubscriptionStatusFn = httpsCallable(functionsInstance, functionNames.checkSubscription);
    fetchUserSessionsFn = httpsCallable(functionsInstance, functionNames.fetchUserSessions);
    exportUserSessionsFn = httpsCallable(functionsInstance, functionNames.exportUserSessions);

    console.log("[profileCloudFunctions] Callable Cloud Function references obtained successfully.");

  } else {
    // Log a warning if the functions instance couldn't be obtained from firebaseConfig
    console.warn("[profileCloudFunctions] Firebase Functions instance not found in firebaseConfig. Cloud function calls will fail.");
  }

} catch (e) {
  // Log any errors during the httpsCallable initialization process
  console.error("[profileCloudFunctions] Error getting Firebase Cloud Function references:", e);
  // Ensure all references remain null if any error occurs
  getUserDataOnLoginFn = null; // <<< Ensure it's null on error
  deleteProfileAndCleanupFn = null;
  sendFriendRequestFn = null;
  acceptFriendRequestFn = null;
  handleFriendRequestFn = null;
  removeFriendFn = null;
  searchUsersFn = null;
  setProfileUsernameFn = null;
  checkSubscriptionStatusFn = null;
  fetchUserSessionsFn = null;
  exportUserSessionsFn = null;
}

// Export the function references (they will be null if initialization failed)
export {
  getUserDataOnLoginFn, // <<< EXPORT the new function reference
  deleteProfileAndCleanupFn,
  sendFriendRequestFn,
  acceptFriendRequestFn,
  handleFriendRequestFn, // Export the combined handler reference
  removeFriendFn,
  searchUsersFn,
  setProfileUsernameFn,
  checkSubscriptionStatusFn,
  fetchUserSessionsFn,
  exportUserSessionsFn
};